import axios from "axios";
import authHeader from "./auth-header";
import IProvider from "../types/provider.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/provider`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (provider: IProvider) => {
  return axios.post(API_URL, provider, { headers: authHeader() });
};

export const update = (id: number, provider: IProvider) => {
  return axios.put(API_URL + "/" + id, provider, { headers: authHeader() });
};

export const getProviders = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveProviders = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};

export const getActiveSubcontractors = () => {
  return axios.get(API_URL + "/actives/subcontractors", { headers: authHeader() });
};
